import { Building2, Globe, Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { Visibility } from '../api/generated/types.gen';
import { SimpleTooltip } from '@/components/SimpleTooltip';

interface ScopeIndicatorProps {
  visibility: Visibility;
  size?: 'sm' | 'md';
}

/**
 * Small read-only icon showing a resource's General access scope — lock
 * (Restricted/private), building (organization), or globe (public). Replaces
 * the old clickable `VisibilityBadge` toggle: scope is now changed inside
 * `ShareDialog`, so this is display-only.
 */
export function ScopeIndicator({
  visibility,
  size = 'md',
}: ScopeIndicatorProps) {
  const { t } = useTranslation();
  const iconClassName = size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5';

  const { Icon, label } =
    visibility === 'public'
      ? { Icon: Globe, label: t('compCommon.shareDialog.scopeAnyoneWithLink') }
      : visibility === 'organization'
        ? {
            Icon: Building2,
            label: t('compCommon.shareDialog.scopeOrganization'),
          }
        : { Icon: Lock, label: t('compCommon.shareDialog.scopeRestricted') };

  return (
    <SimpleTooltip content={label}>
      <span className="inline-flex items-center text-muted-foreground">
        <Icon className={iconClassName} />
      </span>
    </SimpleTooltip>
  );
}
